<p mat-dialog-title>Generowanie plików segmentu {{ segment.name }}</p>
<mat-dialog-content>
	@if (pendingReportLabel(); as label) {
		<app-report-pending-info [label]="label"></app-report-pending-info>
	}
	<div class="d-flex align-items-center gap-3 py-3">
		<div class="flex-grow-1">Rooming List</div>
		<button
			mat-raised-button
			color="primary"
			[disabled]="!!pendingReportLabel()"
			(click)="generateRoomingList('csv')"
		>
			CSV
		</button>
		<button
			mat-raised-button
			color="primary"
			[disabled]="!!pendingReportLabel()"
			(click)="generateRoomingList('spreadsheet')"
		>
			Spreadsheet
		</button>
	</div>
	<hr />
	<div class="d-flex align-items-center gap-3 py-3">
		<div class="flex-grow-1">Ubezpieczenia</div>
		<button
			mat-raised-button
			color="primary"
			[disabled]="!selectedInsurer() || !!pendingReportLabel()"
			(click)="downloadInsuranceList('csv')"
		>
			CSV
		</button>
		<button
			mat-raised-button
			color="primary"
			[disabled]="!selectedInsurer() || !!pendingReportLabel()"
			(click)="downloadInsuranceList('spreadsheet')"
		>
			Spreadsheet
		</button>
	</div>
	@if (insurersLoading()) {
		<div>Ładowanie ubezpieczycieli...</div>
	} @else if (insurers().length) {
		<mat-radio-group
			class="d-flex flex-column"
			name="selectedInsurer"
			[disabled]="!!pendingReportLabel()"
			[ngModel]="selectedInsurer()"
			(ngModelChange)="selectedInsurer.set($event)"
		>
			@for (insurer of insurers(); track insurer) {
				<mat-radio-button [value]="insurer">{{ insurer }}</mat-radio-button>
			}
		</mat-radio-group>
	} @else {
		<div class="text-muted">Brak ubezpieczycieli przypisanych do terminów segmentu.</div>
	}
</mat-dialog-content>
<mat-dialog-actions align="end">
	<button mat-button mat-dialog-close [disabled]="!!pendingReportLabel()">Zamknij</button>
</mat-dialog-actions>
